<template>
  <div id="trivia">
    <section class="pt-5">
      <div class="container pt-5">
        <div class="row pt-5 blanco">
          <div class="col-12 py-4 fXG blanco text-center">
            <strong>T&Eacute;RMINOS Y CONDICIONES</strong>
            
          </div>

          <div class="col-12">
           

          </div>
        </div>
      </div>
    </section>

    <FooterTerminos></FooterTerminos>
  </div>
</template>

<script>
import swal from "sweetalert2";

import FooterTerminos from "@/components/FooterTerminos";

export default {
  components: {
    FooterTerminos,
  },
  data() {
    return {};
  },
  mounted: function () {},
};
</script>

<style lang="scss" scoped>
ul {
  li {
    list-style: none;
  }
}
table {
  margin: 0 auto !important;
  border: 1px solid #afafaf;
}
</style>
